export type Config = {
  documents: LegalDocument[];
  persona: PersonaConfig;
  segment: SegmentConfig;
  statsig: StatsigConfig;
  verifyRevenue: VerifyRevenueConfig;
  verifyAppUrl: string;
  creditAppUrl: string;
};

type StatsigConfig = {
  clientKey: string;
};

type SegmentConfig = {
  writeKey: string;
  cdnUrl: string;
};

type VerifyRevenueConfig = {
  maxWaitSeconds: number;
  pollSeconds: number;
};

export type FeatureFlags = {
  bfcTestimonialPanelExperiment: string;
  enableLinkBankAccount: boolean;
  enableSupportNumber: boolean;
  qfEnableAddressAutocomplete: boolean;
  fgEnableMultipleOffers: boolean;
  fgEnablePreQualificationQuiz: boolean;
  fgEnableReorderedCreditAppFlow: boolean;
};

export type PersonaConfig = {
  templateId: string;
  environment: 'sandbox' | 'production';
};

export type LegalDocumentKey =
  | 'platform_terms'
  | 'privacy_policy'
  | 'credit_authorization'
  | 'card_program_terms'
  | 'commercial_financing_disclosure'
  | 'account_linking_terms';

export type LegalDocument = {
  name: string;
  url: string;
  key: LegalDocumentKey;
};

export const OTP_APPLY_LEGAL_DOCUMENTS: LegalDocumentKey[] = ['platform_terms', 'privacy_policy', 'card_program_terms'];
export const OTP_VERIFICATION_LEGAL_DOCUMENTS: LegalDocumentKey[] = ['platform_terms', 'privacy_policy'];
export const CREDIT_REPORT_AUTH_DOC: LegalDocumentKey = 'credit_authorization';

export const ACCOUNT_LINKING_TERMS_DOC: LegalDocumentKey = 'account_linking_terms';
